import { useSyncExternalStore } from 'react';

type Listener = () => void;

let failed = false;
const listeners = new Set<Listener>();

function subscribe(listener: Listener) {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
}

function getSnapshot() {
    return failed;
}

export function setMapsAuthFailed() {
    if (failed) return;
    failed = true;
    listeners.forEach((l) => l());
}

export function useMapsAuthFailed(): boolean {
    return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
